import React from 'react';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import Icon4 from '../ReactIcons/icon4';
import { ICON_ANCHOR, ICON_SIZE } from '.';

const mapIcon4 = L.divIcon({
    html: ReactDOMServer.renderToString(<Icon4 />),
    iconSize: ICON_SIZE,
    iconAnchor: ICON_ANCHOR
});

export default mapIcon4;